import * as Yup from 'yup'

const menusInProbingStatusReportSchema = Yup.object().shape({
  includeOnlyStuckMenus: Yup.boolean().required(
    'includeOnlyStuckMenus is required',
  ),
})

export default menusInProbingStatusReportSchema
